"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var AuthService = /** @class */ (function () {
    function AuthService() {
        this._userId = null;
        this._schoolId = null;
        this._role = null;
        this._brand = null;
        this._jwtKey = 'jwt';
    }
    Object.defineProperty(AuthService.prototype, "userId", {
        /**
         * get userId
         * @description Retrieve data from the JWT if necessary and Return the user's ID
         */
        get: function () {
            if (!this._userId) {
                this.refreshUserData();
            }
            return this._userId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "schoolId", {
        /**
         * get schoolId
         * @description Retrieve data from the JWT if necessary and Return the user's school ID
         */
        get: function () {
            if (!this._schoolId) {
                this.refreshUserData();
            }
            return this._schoolId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "role", {
        /**
         * get role
         * @description Retrieve data from the JWT if necessary and Return the user's role
         */
        get: function () {
            if (!this._role) {
                this.refreshUserData();
            }
            return this._role;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "brand", {
        /**
         * get brand
         * @description Retrieve data from the JWT if necessary and Return the user's brand
         */
        get: function () {
            if (!this._brand) {
                this.refreshUserData();
            }
            return this._brand;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * getDecodedToken
     * @param token the jwt token in string format
     * @description Returns a decoded token
     */
    AuthService.prototype.getDecodedToken = function (token) {
        return jsonwebtoken_1.default.decode(token);
    };
    /**
     * getToken
     * @description Returns the token stored in localStorage
     */
    AuthService.prototype.getToken = function () {
        return localStorage.getItem(this._jwtKey);
    };
    /**
     * store
     * @description Save session data
     *
     * @param session
     */
    AuthService.prototype.store = function (session) {
        if (session.token) {
            var decoded = void 0;
            try {
                // set decoded token in localstorage
                decoded = this.getDecodedToken(session.token);
                localStorage.setItem(this._jwtKey, session.token);
                // set user id
                this._userId = decoded.sub;
                // detect common token structure
                if (decoded.dfCustom && decoded.roles && decoded.roles.length) {
                    this._schoolId = decoded.dfCustom.schoolId;
                    this._role = decoded.roles[0];
                    this._brand = decoded.dfCustom.brand;
                    return true;
                }
                // detect legacy token structure
                if (decoded.df_custom && decoded.df_custom.role) {
                    this._role = decoded.df_custom.role;
                    this._schoolId = decoded.df_custom.schoolId;
                    return true;
                }
            }
            catch (err) {
                console.log('Failed to store JWT: ' + err);
                localStorage.removeItem(this._jwtKey);
            }
        }
        return false;
    };
    /**
     * clearAuthentication
     * @description Remove the JWT and user data from local storage and emit an event indicating that the auth information has changed.
     */
    AuthService.prototype.clearAuthentication = function () {
        localStorage.removeItem('jwt');
        this._userId = null;
        this._schoolId = null;
        this._role = null;
        this._brand = null;
    };
    /**
     * refreshUserData
     * @description Refresh this._schoolId and this._userId.
     */
    AuthService.prototype.refreshUserData = function () {
        var token = localStorage.getItem(this._jwtKey);
        if (token && !this.isTokenExpired(token)) {
            var decoded = this.getDecodedToken(token);
            // set user id
            this._userId = decoded.sub;
            // common token structure
            if (decoded.dfCustom && decoded.roles && decoded.roles.length) {
                this._schoolId = decoded.dfCustom.schoolId;
                this._role = decoded.roles[0];
                this._brand = decoded.dfCustom.brand;
                return;
            }
            // detect legacy token structure
            if (decoded.df_custom && decoded.df_custom.role) {
                this._role = decoded.df_custom.role;
                this._schoolId = decoded.df_custom.schoolId;
            }
        }
    };
    /**
     * getTokenExpirationDate
     * @param token
     *
     * @description Returns a Date object for the expiration if it exists on the token, null otherwise
     *
     * NOTE: This adapted from the auth0/angular2-jwt package
     */
    AuthService.prototype.getTokenExpirationDate = function (token) {
        var decoded = this.getDecodedToken(token);
        if (!decoded || !decoded.exp) {
            return null;
        }
        else {
            var date = new Date(0);
            date.setUTCSeconds(decoded.exp);
            return date;
        }
    };
    /**
     * isTokenExpired
     * @param token
     *
     * @description Returns if the token has expired or not.  Will return true for invalid or empty tokens. Returns false for tokens without expiration date.
     *
     * NOTE: This adapted from the auth0/angular2-jwt package
     */
    AuthService.prototype.isTokenExpired = function (token) {
        if (jsonwebtoken_1.default.decode(token) === null || token === '') {
            return true;
        }
        var date = this.getTokenExpirationDate(token);
        if (date === null) {
            return false;
        }
        return date.valueOf() <= new Date().valueOf();
    };
    /**
     * checkValidToken
     * @description Return true if the JWT token is in local storage and has not expired.
     * If the JWT in storage has expired, remove from local storage and return false.
     */
    AuthService.prototype.checkValidToken = function () {
        var token = localStorage.getItem('jwt');
        var valid = !!token;
        if (valid) {
            try {
                // invalid JWTs generate an error that needs to be caught
                if (this.isTokenExpired(token)) {
                    valid = false;
                }
            }
            catch (err) {
                console.log('Invalid Token. Error: ', err);
                valid = false;
            }
            // remove invalid token
            if (!valid) {
                console.log('Invalid JWT, removing.');
                localStorage.removeItem('jwt');
            }
        }
        return valid;
    };
    /**
     * isAuthenticated
     * @description Check whether there is currently an authenticated user
     */
    AuthService.prototype.isAuthenticated = function () {
        return this.checkValidToken();
    };
    return AuthService;
}());
exports.AuthService = AuthService;
